/* eslint-disable filenames/match-regex */
import DateUtils from 'utils/DateUtils';
import Format from 'utils/Format';
import {  InfoHotelModel, OrderModel } from './../../models/order.d';
import { formatDate } from './printService';
export function renderHTMLBillInvoice(data, infoHotel) {
    const newDate = DateUtils.formatDayAndTimePicker(new Date()).split('/')[1];
    const _user = localStorage.getItem('Apec_Account');
    const user = _user && JSON.parse(_user).username;
    const sumTotal = Array.isArray(data?.items) 
    ? data.items.reduce((sum, item) => sum + ((item.price || 0) * (item.qty || 0) - (item.subDiscount || 0)), 0) 
    : 0;
    const sumDiscount = Array.isArray(data?.items) 
    ? data.items.reduce((sum, item) => sum + (item.subDiscount || 0), 0) 
    : 0;
    console.log('data', data, infoHotel);
    const renderColumn = () => {
        let _column = '';
        for(let i=0; i < data?.items?.length; i++) {
            _column += `<tr style="vertical-align:top;">
            <td style="width:0px;height:22px;"></td>
            <td colspan="1" style="width:0px;height:22px;"></td>
            <td class="csB03FD833 bd"  rowspan="2"  style="width:21px;height:27px;line-height:27px;text-align:left;vertical-align:middle; word-break: break-word;">${i + 1}</td>
            <td class="csB03FD833 bd" colspan="14" rowspan="2" style="width:104px;height:27px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>${data?.items[i].itemName}</nobr></td>
            <td class="csB03FD833 bd" colspan="3" rowspan="2" style="width:40px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${data?.items[i].unitName}</nobr></td>
            <td class="csF09495AB bd" colspan="1" rowspan="2" style="width:52px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${data?.items[i].qty}</nobr></td>
            <td class="csF09495AB bd" colspan="10"  rowspan="2" style="width:52px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data?.items[i].price)}</nobr></td>
            <td class="csF09495AB bd" colspan="12" rowspan="2" style="width:60px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(Number(data?.items[i].price || 0) * Number( data?.items[i].qty || 0))}</nobr></td>
            <td class="csF09495AB bd" colspan="10" rowspan="2" style="width:47px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data?.items[i].subDiscount || 0) }</nobr></td>
            <td class="csF09495AB bd" colspan="10" rowspan="2" style="min-width:120px;height:27px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD( Number(data?.items[i].price || 0) * Number( data?.items[i].qty || 0) - Number(data?.items[i].subDiscount || 0))}</nobr></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:15px;"></td>
            <td class="csA8DCAC4A" colspan="2" style="width:2px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
            <td class="csA8DCAC4A" style="width:25px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
            <td></td>
        </tr>`;
        } 
        return _column;
    };
    return `
    <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<!-- saved from url=(0016)http://localhost -->
<html>
<head>
	<title>Document</title>
	<meta HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=utf-8"/>
	<style type="text/css">
    .cs4FADFF8F {
        color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right:#FFFFFF 2px solid;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:bold; font-style:normal; }
		.cs8E2DFAB {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:italic; }
		.csC1740083 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:italic; padding-left:2px;}
		.cs8EA18762 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:2px;}
		.cs8EA187A8 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:4px;}
		.cs46A3E351 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-top:5px;padding-left:5px;padding-bottom:5px;}
		.cs86EE7AC5 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-top:5px;padding-left:5px;padding-right:5px;padding-bottom:5px;}
		.csB23251C5 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:italic; }
		.csF019F6E5 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:italic; padding-left:2px;}
		.csF019F59F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:italic; padding-left:4px;}
		.csD589D4E {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:2px;}
		.cs5F7AA6EF {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:2px;padding-right:2px;}
		.csD589D10 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:4px;}
		.csD589D2F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:5px;}
		.csB03FD833 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-top:5px;padding-left:5px;padding-bottom:5px;}
		.csF09495AB {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-top:5px;padding-left:5px;padding-right:5px;padding-bottom:5px;}
		.csF3554C5D {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:bold; font-style:normal; padding-left:2px;}
		.csE6322FFC {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
		.cs9A77F515 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:normal; font-style:italic; padding-left:1px;}
		.cs9A77F5F6 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:normal; font-style:italic; padding-left:2px;}
		.csE9BCDB7C {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:normal; font-style:normal; padding-left:1px;}
		.csA8DCAC4A {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:normal; font-style:normal; }
		.cs57813273 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:20px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
		.csAC6A4475 {height:0px;width:0px;overflow:hidden;font-size:0px;line-height:0px;}
        .bg {
            background-color: Silver; 
        }
        .bd {
            border: 1px solid gray;
            padding: 4px;
        }
        .bd-bottom {
            border-bottom: 1px solid gray;
            padding: 4px;
        }
        .bd-left {
            border-left: none;
        }
	</style>
</head>
<body leftMargin=10 topMargin=10 rightMargin=10 bottomMargin=10 style="background-color:#FFFFFF; margin-top: 20px;  height: fix-content !important">
<table cellpadding="0" cellspacing="0" border="0" style="border-width:1px;empty-cells:show;width:485px;position:relative;">
	<tr>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:25px;"></td>
		<td style="height:0px;width:14px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:18px;"></td>
		<td style="height:0px;width:12px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:3px;"></td>
		<td style="height:0px;width:8px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:6px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:11px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:27px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:11px;"></td>
		<td style="height:0px;width:13px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:6px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:11px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:7px;"></td>
		<td style="height:0px;width:12px;"></td>
		<td style="height:0px;width:3px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:7px;"></td>
		<td style="height:0px;width:13px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:3px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:2px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:27px;"></td>
		<td style="height:0px;width:23px;"></td>
		<td style="height:0px;width:13px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:33px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:2px;"></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:16px;"></td>
		<td></td>
		<td></td>
		<td class="csA8DCAC4A" colspan="15" rowspan="4" style="width:134px;height:65px;text-align:left;vertical-align:top;"><div style="overflow:hidden;width:134px;height:65px;">
			<img alt="" src="C:\APPLICATION\LIVE_SMARTHOTEL\APPS\PMS\WebAPI\assets/uploads/medias/image/1eff3a37-2754-4efe-8ef6-b49e9b298887.jpg" style="width:0px;height:0px;" /></div>
		</td>
		<td></td>
		<td></td>
		<td class="cs8EA18762" colspan="42" style="width:305px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>${infoHotel.hotelName || ''}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td class="cs8EA18762" colspan="40" style="width:41px;height:17px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Website: ${infoHotel.website|| ''}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:16px;"></td>
		<td></td>
		<td></td>
		<td></td>
        <td></td>
		<td class="cs8EA18762" colspan="38"  style="width:27px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Add: ${infoHotel.address|| ''}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:16px;"></td>
		<td></td>
		<td></td>
		<td></td>
        <td></td>
		<td class="cs8EA18762" style="width:48px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Tax&nbsp;code: ${infoHotel.taxCode|| ''}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</nobr></td>
		<td class="cs8EA187A8" colspan="15"  style="width:41px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr> Hotline: ${infoHotel.phone|| ''}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:25px;"></td>
		<td class="cs57813273" colspan="61" style="width:479px;height:25px;line-height:23px;text-align:center;vertical-align:middle;"><nobr>H&#211;A&nbsp;ĐƠN&nbsp;/&nbsp;INVOICE</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:15px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td></td>
		<td class="cs8EA18762" style="width:68px;height:17px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Ng&#224;y&nbsp;mở&nbsp;b&#224;n</nobr>
        </td>
		<td class="csD589D2F" colspan="19" style="width:135px;height:17px;line-height:12px;text-align:left;vertical-align:top;"><nobr>(Open&nbsp;Date):&nbsp;${data.createdDate}</nobr></td>
		<td></td>
		<td></td>
		<td class="cs8EA18762" style="width:50px;height:17px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Địa điểm</nobr></td>
		<td class="csD589D10" colspan="19" style="width:109px;height:17px;line-height:12px;text-align:left;vertical-align:top;"><nobr>(Location):&nbsp;${data.location}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:20px;"></td>
		<td></td>
		<td class="cs8EA18762" style="width:68px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>M&#227;&nbsp;giao&nbsp;dịch</nobr></td>
		<td class="csD589D4E" colspan="20" style="width:145px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>&nbsp;(Order&nbsp;No):&nbsp;${data.orderNo}</nobr></td>
		<td></td>
		<td class="cs8EA18762" style="width:45px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Ngày in</nobr></td>
		<td class="csB23251C5" colspan="19" style="width:109px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>&nbsp;(Print&nbsp;Date):&nbsp;${formatDate(newDate)?.slice(0,11)}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td></td>
		<td class="cs8EA18762"  colspan="0.5" style="width:30px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>Số khách</nobr></td>
		<td class="csD589D10" colspan="20" style="width:154px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>(Total&nbsp;Guest):&nbsp;${data.noOfGuest}</nobr></td>
		<td></td>
		<td class="cs8EA18762"  style="width:37px;height:16px;line-height:12px;text-align: left;vertical-align:top;"><nobr>Số bàn</nobr></td>
		<td class="csD589D2F" colspan="20" style="width:117px;height:16px;line-height:12px;text-align:left;vertical-align:top;"><nobr>(Table&nbsp;No):&nbsp;${data.tableCode}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:11px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
    <table style="border-width:1px;empty-cells:show;width:550px;position:relative;">
    <tr style="vertical-align:top;">
		<td colspan="1" style="width:0px;height:24px;"></td>
        <td class="csA8DCAC4A" colspan="1" style="width:2px;height:3px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
        <td class="cs4FADFF8F bg bd" colspan="1" style="width:10px; height:20px; text-align:left; vertical-align:middle;">STT<br>(No)</td>
		<td class="cs4FADFF8F bg bd" colspan="14" style="width:150px;height:24px;line-height:9px;text-align:center;vertical-align:middle; line-height: calc(1em + 1px);"><nobr>Tên hàng hoá, dịch vụ<br>(Description)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="3" style="width:24px;height:24px;line-height:9px;text-align:center;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>ĐVT<br>(Unit)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="1" style="width:45px;height:24px;line-height:9px;text-align:center;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>Số lượng<br>(Quantity)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="10" style="width:51px;height:24px;line-height:9px;text-align:center;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>Đơn giá<br>(Unit Price)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="12" style="width:51px;height:24px;line-height:9px;text-align:center;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>Số tiền<br>(Amount)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="10" style="width:51px;height:24px;line-height:9px;text-align:center;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>Chiết khấu<br>(Discount)</nobr></td>
		<td class="cs4FADFF8F bg bd" colspan="9" style="min-width:120px;height:24px;line-height:9px;text-align:right;vertical-align:middle;line-height: calc(1em + 1px);"><nobr>Số tiền sau CK<br>(Final Amount)</nobr></td>
	</tr>
    ${renderColumn()}
    <tr style="vertical-align:top;" >
            <td style="width:0px;height:22px;"></td>
            <td style="width:0px;height:22px;"></td>
            <td class="cs4FADFF8F bd" rowspan="2" colspan="1" style="width:60px;height:27px;line-height:12px;text-align:left;vertical-align:middle;">CỘNG</td>
            <td class="csB03FD833 bd-bottom " colspan="14" rowspan="2" style="width:104px;height:27px;line-height:12px;text-align:left;vertical-align:middle;"><nobr></nobr></td>
            <td class="csB03FD833 bd-bottom " colspan="3" rowspan="2" style="width:40px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr></nobr></td>
            <td class="csF09495AB bd-bottom " colspan="1" rowspan="2" style="width:12px;height:27px;line-height:12px;text-align:right;vertical-align:middle;"><nobr></nobr></td>
            <td class="csF09495AB bd-bottom " colspan="10" rowspan="2" style="width:52px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr></nobr></td>
            <td class="cs4FADFF8F bd" colspan="12" rowspan="2" style="width:60px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data?.subAmount)}</nobr></td>
            <td class="cs4FADFF8F bd" colspan="10" rowspan="2" style="width:47px;height:27px;line-height:12px;text-align:center;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(sumDiscount || 0)}</nobr></td>
            <td class="cs4FADFF8F bd" colspan="10" rowspan="2" style="min-width:120px;;height:27px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(sumTotal || 0)}</nobr></td>
            <td></td>
     </tr>
    <table>
   
	<table>
    <tr style="vertical-align:top;">
		<td class="csA8DCAC4A" colspan="2" style="width:2px;height:3px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:25px;height:3px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
    <td colspan="4" rowspan="12" style="min-width:180px;height:180px;">
    <img alt="" src="https://api.vietqr.io/image/970436-1041677509-6BKQEDo.jpg?accountName=CTCP QLKSDV MANDALA CN MUI NE&amount=200000&addInfo=FR250123 0002" style="width:180px;height:180px;" /></div>
    </td>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:11px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
    <tr style="vertical-align:top;">
    <td style="width:0px;height:11px;"></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
</tr>
    <tr style="vertical-align:top;">
        <td class="csF3554C5D" colspan="2" style="width:50px;height:14px;line-height:13px;text-align:left;vertical-align:top;">Tổng tiền<span class="cs9A77F5F6"><nobr>&nbsp;&nbsp;(Total Amt)&nbsp${data?.isDiscountPer === 'Y' ? `(${data?.discount}%)` : ''}:</nobr></span></td>
        <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data.subAmount)}  VND</nobr></td>
        <td></td>
    </tr>

    <tr style="vertical-align:top;">
    <td class="csF3554C5D"   colspan="2" style="width:94px;height:14px;line-height:13px;text-align:left;vertical-align:top;"><nobr>Gi&#225;&nbsp;trị&nbsp;chiết&nbsp;khấu</nobr><span class="cs9A77F5F6">&nbsp;&nbsp;&nbsp;(Bill&nbsp;Discount):</span></td>
    <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data.totalDiscount)} VND</nobr></td>
    </tr>
    <tr>
            <td class="csF3554C5D"  colspan="2" style="width:50px;height:14px;line-height:13px;text-align:left;vertical-align:top;">Th&#224;nh&nbsp;tiền <span class="cs9A77F5F6" ><nobr>&nbsp;&nbsp;(Sub&nbsp;Amount):</nobr></span></td>
            <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data.amountNet)} VND</nobr></td>
     </tr>

     <tr style="vertical-align:top;">
         <td class="csF3554C5D" colspan="2" style="width:50px;height:14px;line-height:13px;text-align:left;vertical-align:top;"><nobr>Service&nbsp;charge</nobr><span class="cs9A77F5F6"><nobr>&nbsp;&nbsp;&nbsp;(5%):</nobr></span></td>
         <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data?.svc)} VND</nobr></td>
     </tr>

     <tr style="vertical-align:top;">
            <td class="csF3554C5D"  colspan="2"  " style="width:50px;height:17px;line-height:13px;text-align:left;vertical-align:top;"><nobr>Tax&nbsp;Amount:</nobr></td>
            <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data?.vat)} VND</nobr></td>
    </tr>

    <tr style="vertical-align:top;">
            <td class="csF3554C5D"  colspan="2  " style="width:50px;height:14px;line-height:13px;text-align:left;vertical-align:top;">TTĐB:</td>
            <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data?.ttdb)} VND</nobr></td>
            <td></td>
     </tr>
    <tr style="vertical-align:top;">
            <td class="csF3554C5D"  colspan="2" style="width:117px;height:14px;line-height:13px;text-align:left;vertical-align:top;"><nobr>Tổng&nbsp;tiền&nbsp;thanh&nbsp;to&#225;n</nobr><span class="cs9A77F5F6"><nobr>&nbsp;&nbsp;(Grand&nbsp;Total):</nobr></span></td>
            <td class="csE6322FFC" colspan="15" style="width:90px;height:14px;line-height:13px;text-align: right;vertical-align:top;"><nobr>${Format.formatMoneyNotD(data?.total)} VND</nobr></td>
            <td></td>
    </tr>

	<tr style="vertical-align:top;">
		<td style="width:0px;height:9px;"></td>
		<td class="csA8DCAC4A" style="width:1px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:40px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:48px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:12px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:5px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:31px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:4px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:39px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:6px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:2px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:16px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:12px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="9" style="width:48px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:15px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:3px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:10px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:71px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:33px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:9px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>

<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td class="csA8DCAC4A" style="width:5px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td class="csF3554C5D" colspan="4" style="width:99px;height:17px;line-height:13px;text-align:left;vertical-align:top;"><nobr>Số&nbsp;tiền&nbsp;bằng&nbsp;chữ</nobr><span class='cs9A77F5F6'><nobr>&nbsp;(In&nbsp;word): ${' '}${data?.texT_TOTAL}</nobr></span></td>
		<td class="cs9A77F5F6" colspan="33" style="width:98px;height:16px;line-height:13px;text-align:left;vertical-align:top;"></td>
        </tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:16px;"></td>
		<td class="csF3554C5D" colspan="5" style="width:114px;height:16px;line-height:13px;text-align:left;vertical-align:top;"><nobr>H&#236;nh&nbsp;thức&nbsp;thanh&nbsp;to&#225;n</nobr><span class='cs9A77F5F6'><nobr>(Payment&nbsp;Method): ${data.payment}</nobr></span></td>
		<td class="cs9A77F5F6" colspan="33" style="width:98px;height:16px;line-height:13px;text-align:left;vertical-align:top;"></td>
		<td class="csA8DCAC4A" style="width:5px;height:16px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:16px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td class="csA8DCAC4A" style="width:1px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:40px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:48px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:12px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:5px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:31px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:4px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:39px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:6px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:2px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csE9BCDB7C" colspan="33" style="width:265px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:22px;"></td>
		<td class="csA8DCAC4A" style="width:1px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csE6322FFC" colspan="2" style="width:106px;height:22px;line-height:13px;text-align:center;vertical-align:top;"><nobr>Cashier&nbsp;signature</nobr></td>
		<td class="csA8DCAC4A" style="width:1px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csE6322FFC" colspan="10" style="width:95px;height:22px;line-height:13px;text-align:center;vertical-align:top;"><nobr>Guest&nbsp;signature</nobr></td>
		<td class="csA8DCAC4A" style="width:13px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:33px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:22px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:67px;"></td>
		<td class="csA8DCAC4A" style="width:1px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:40px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:48px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:12px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:5px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:31px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:4px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="3" style="width:39px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:6px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:2px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:16px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:12px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="9" style="width:48px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:15px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:3px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:10px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:71px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:33px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:67px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:15px;"></td>
		<td class="csA8DCAC4A" style="width:1px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csE6322FFC" colspan="1" style="width:185px;height:15px;line-height:13px;text-align:center;vertical-align:top;"><nobr>${user}</nobr></td>
		<td class="csA8DCAC4A" style="width:13px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:6px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:2px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:16px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:10px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:9px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:12px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="9" style="width:48px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:15px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:3px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="2" style="width:10px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" colspan="5" style="width:71px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:13px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:33px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:5px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td class="csA8DCAC4A" style="width:1px;height:15px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:2px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
    </table>
</table>
</body>
</html>
    `;

}
